import { callApiV2 } from "../util/apiCaller";
import {
  SET_AUTH_STATE,
  SET_IS_AUTHENTICATION,
  SET_USER_TYPE,
  SET_USER_ID,
  SET_USER_CONFIGS,
  SET_USER,
  FETCHING_APPROVAL_LIST,
  FETCHING_APPROVAL_LIST_SUCCESS,
  FETCHING_APPROVAL_LIST_FAILURE,
  MEMBER_APPROVAL_STATUS,
  MEMBER_DECLINE_STATUS,
  MOSQUE_DECLINE_STATUS,
} from "./appActionType";
import { showNotification } from "../util/Utility";
import { fetchCustomerInfoList, fetchPlanList } from "./Admin/adminAction";
import { FETCH_ORGANISATION_ENTITIES } from "./Admin/adminActionType";
import { fetchUserDashboardStats } from "../redux/UserReducer/userAction";

export const setAuthState = (authState) => ({
  type: SET_AUTH_STATE,
  authState,
});

export const setAuthentication = (state) => ({
  type: SET_IS_AUTHENTICATION,
  state,
});

export const setUserId = (id) => ({
  type: SET_USER_ID,
  id,
});

export const setUserType = (type) => ({
  type: SET_USER_TYPE,
  userType: type,
});
export const setUser = (user)=>({
  type:SET_USER,
  user:user
})

export const setUserRoleConfigs = (userConfigs) => ({
  type: SET_USER_CONFIGS,
  userConfigs: userConfigs,
});

export const getUserRoleConfig =
  (userId, role) => async (dispatch, getState) => {
    try {
      const res = await callApiV2({
        method: "post",
        endpoint: `auth/getUserConfig`,
        body: { userId, role },
      });
      if (res?.data) {
        dispatch(setUserRoleConfigs(res?.data));
      }
    } catch (error) {
      console.log("Error fetching user role config", error);
    }
  };

export const fetchUserProfile = (userId, role) => async (dispatch) => {
  try {
    const userDetails = await callApiV2({
      method: "post",
      endpoint: `auth/getUserProfile`,
      body: { userId, role },
    });
    console.log('userDetails.data :::: ',userDetails.data);
    
    dispatch(setUser(userDetails?.data))
  } catch (error) {
    console.log("Error fetching userDetails", error);
  }
};


export const fetchApprovalList = (entityId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: FETCHING_APPROVAL_LIST,
      isFetching: true,
    });
    const res = await callApiV2({
      method: "post",
      endpoint: `admin/dashboard/entity/${entityId}/approval-list`,
    });
    if (res?.status === "Success") {
      dispatch({
        type: FETCHING_APPROVAL_LIST_SUCCESS,
        isFetching: false,
        list: res?.data?.list,
        count: res?.data?.count,
      });
    } else {
      showNotification("error", "Er is iets misgegaan..");
      dispatch({
        type: FETCHING_APPROVAL_LIST_FAILURE,
        isFetching: false,
      });
    }
  } catch (err) {
    dispatch({
      type: FETCHING_APPROVAL_LIST_FAILURE,
      isFetching: false,
    });
  }
};

export const fetchOrganisationEntities =
  (organisation_id) => async (dispatch) => {
    try {
      const res = await callApiV2({
        method: "get",
        endpoint: `admin/dashboard/organisation/${organisation_id}/entity-list`,
      });
      if (res?.status === "Success") {
        dispatch({
          type: FETCH_ORGANISATION_ENTITIES,
          entities: res.data,
        });
        dispatch(fetchUserDashboardStats(res?.data[0]._id));
        dispatch(fetchApprovalList(res?.data[0]?._id));
        dispatch(fetchPlanList(res?.data[0]?._id));
      }
    } catch (err) {
      console.log(err);
    }
  };

export const memberApprove =
  (memberSubId, approvalId, userId, isDigitalFormOnboarded) => async (dispatch, getState) => {
    try {
      const activeEntity = getState()?.adminReducer?.activeEntity;
      const pageNum = getState()?.adminReducer?.customerInfo?.pageNum;
      const pageSize = getState()?.adminReducer?.customerInfo?.pageSize;
      const res = await callApiV2({
        method: "post",
        endpoint: `onboarding/member/${memberSubId}/approval/${approvalId}/approve?isDigitalFormOnboarded=${isDigitalFormOnboarded}`,
      });
      if (res?.status === "Success") {
        showNotification("success", "Lid succesvol goedgekeurd.");
        fetch(
          `https://engine.mosqapp.com/api/v1/send-notification?userId=${userId}`,
          {
            method: "POST",
            body: JSON.stringify({
              message: {
                notification: {
                  title: "Account approval success",
                  body: "Welcome to MOSQAPP. The mosque admin has approved your account. Please login",
                },
              },
            }),
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
          }
        )
          .then((response) => response.json())
          .then((json) => console.log(json));

        dispatch(
          fetchCustomerInfoList({
            entity_id: activeEntity?._id,
            pageSize: pageSize,
            pageNum: pageNum,
          })
        );
        dispatch({
          type: MEMBER_APPROVAL_STATUS,
          approvalId,
        });
      }
    } catch (err) {
      showNotification("error", "Er is iets misgegaan..");
    }
  };

export const memberDecline =
  (approvalId, activeEntityId) => async (dispatch, getState) => {
    try {
      const res = await callApiV2({
        method: "post",
        endpoint: `admin/dashboard/approval/decline/${approvalId}`,
      });
      if (res?.status === "Success") {
        showNotification("success", "Agent afgewezen.");
        dispatch({
          type: MEMBER_DECLINE_STATUS,
          approvalId,
        });
      }
    } catch (err) {
      showNotification("success", "Agent afgewezen.");
    }
  };

  export const entityDecline =
  (approvalId) => async (dispatch, getState) => {
  try {
    const res = await callApiV2({
      method: "post",
      endpoint: `owner/dashboard/approval/decline/${approvalId}`,
    });
    if (res?.status === "Success") {
      showNotification("success", "Entity declined.");
      dispatch({
        type: MOSQUE_DECLINE_STATUS,
        approvalId,
      });
      window.location.href = "/user/members";
    }
  } catch (err) {
    showNotification("error", "Er is iets misgegaan..");
  }
};
